import { render, staticRenderFns } from "./NewsletterSubscribe.vue?vue&type=template&id=6c296fca&scoped=true&"
import script from "./NewsletterSubscribe.vue?vue&type=script&lang=js&"
export * from "./NewsletterSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSubscribe.vue?vue&type=style&index=0&id=6c296fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c296fca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
